// import moment from "moment-timezone";

// // Get user preferences from sessionStorage
// const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];
// const DateFormat = signInDetails[0]?.DateFormat || "YYYY-MM-DD";
// const TimeFormat = signInDetails[0]?.TimeFormat || "HH:mm";
// const TimeZone = signInDetails[0]?.TimeZone?.split(" ")[0] || "UTC";

// // Define time format mappings
// const timeFormatMap = {
//     "12-hour": "hh:mm A",
//     "24-hour": "HH:mm",
//     "ISO": "YYYY-MM-DDTHH:mm:ssZ",
// };

// // Resolve the time format dynamically
// const mappedTimeFormat = timeFormatMap[TimeFormat] || "HH:mm";

// // Function to format date and time based on session preferences
// export const formatDate = (dateString) => {
//     if (!dateString) return "N/A"; // Handle missing or empty date strings

//     try {
//         const utcDate = moment.utc(dateString); // Parse input date as UTC
//         const localizedDate = utcDate.tz(TimeZone); // Convert to target timezone

//         if (TimeFormat === "ISO") {
//             return localizedDate.toISOString(); // Return ISO format
//         } else {
//             return localizedDate.format(`${DateFormat} ${mappedTimeFormat}`);
//         }
//     } catch (error) {
//         return "N/A"; // Return fallback if an error occurs
//     }
// };



import moment from "moment-timezone";

// Get user preferences from sessionStorage
const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];

// Validate date format (must contain YYYY, MM, and DD tokens)
const isValidDateFormat = (format) => {
    return typeof format === 'string' &&
        /Y{2,4}/.test(format) && /M{1,2}/.test(format) && /D{1,2}/.test(format);
};

// Fallback to U.S. date format if session value is invalid
const sessionDateFormat = signInDetails[0]?.DateFormat;
const DateFormat = isValidDateFormat(sessionDateFormat) ? sessionDateFormat : "MM/DD/YYYY";

// Get time format and timezone
const TimeFormat = signInDetails[0]?.TimeFormat || "24-hour";
const TimeZone = signInDetails[0]?.TimeZone?.split(" ")[0] || "UTC";

// Define time format mappings
const timeFormatMap = {
    "12-hour": "hh:mm A",
    "24-hour": "HH:mm",
    "ISO": "YYYY-MM-DDTHH:mm:ssZ",
};

// Resolve the time format dynamically
const mappedTimeFormat = timeFormatMap[TimeFormat] || "HH:mm";

// Final function to export
export const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    try {
        const utcDate = moment.utc(dateString); // Parse input as UTC
        const localizedDate = utcDate.tz(TimeZone); // Convert to target timezone

        if (TimeFormat === "ISO") {
            return localizedDate.toISOString();
        } else {
            return localizedDate.format(`${DateFormat} ${mappedTimeFormat}`);
        }
    } catch (error) {
        return "N/A";
    }
};
